export function getElementXPath(el: Element | null, context: Element = document.body): string {
  let xpath = ''
  while (el !== null) {
    if (el.id !== '') {
      xpath = `//*[@id="${el.id}"]` + xpath
      break
    }
    if (el === context) {
      xpath = `/${el.tagName.toLowerCase()}` + xpath
      if (document.body === context) {
        xpath = `/html${xpath}`
      }
      break
    }

    let siblings = el.parentNode ? el.parentNode.childNodes : []
    let sameNodeCount = 1
    let ix = 1

    let i = 0
    for (let l = siblings.length; i < l; i++) {
      let sibling = siblings[i] as Element
      if (sibling === el) {
        ix = sameNodeCount
      } else if (sibling.nodeType === 1 && sibling.tagName === el.tagName) {
        sameNodeCount++
      }
    }
    xpath = `/${el.tagName.toLowerCase()}` + (sameNodeCount > 1 ?  `[${ix}]` : '') + xpath
    el = el.parentNode as Element
  }

  return xpath
}
/**
 * 计算点击事件触发的 dom 在组件维度的 path
 * 最终得到如：/Root/App/Layout/ASpin/Dashboard
 * @param el Element
 */
export function getElementVPath (el: any): string {
  let vpath = ''
  while(el != null && el.__vue__ == null) {
    el = el.parentNode
  }
  if (el) {
    let vm = el.__vue__
    while (vm !== null && vm !== undefined) {
      // 匿名组件命名为 Anonymous
      let parent = vm.$parent
      let name = vm.$options.name || (parent && parent.$parent ? 'Anonymous' : 'Root')
      const children = parent ? parent.$children || [] : []
      let ix = 1
      let sameNodeCount = 1

      for (let i = 0; i < children.length; i++) {
        if (vm === children[i]) {
          ix = sameNodeCount
        } else if (children[i].constructor === vm.constructor) {
          sameNodeCount++
        }
      }

      vpath = `/${name}` + (sameNodeCount > 1 ? `[${ix}]` : '') + vpath
      vm = parent
    }
  }

  return vpath
}
